import useQueryCategories from "../../../hooks/queries/useQueryCategories.js";
import {Cascader} from "../../../../__snowpack__/pkg/antd.js";
import React, {useEffect} from "../../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
export default function CategoriesCascader(props) {
  const {value, channelId, countryCode, disabled, onChange, ...restProps} = props;
  const {formatMessage} = useIntl();
  const {data: categories = [], run, mutate} = useQueryCategories({channelId, countryCode}, {manual: true});
  useEffect(() => {
    if (channelId && countryCode) {
      run({channel: channelId, countryCode});
    } else {
      mutate([]);
      if (value) {
        onChange?.([]);
      }
    }
  }, [channelId, countryCode]);
  const showSearch = {
    filter: (inputValue, path, names) => {
      return path.some((option) => option[names.label].toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    sort: () => 1,
    render: (inputValue, path, prefixCls, names) => {
      return /* @__PURE__ */ React.createElement("span", {
        title: path.map((option) => option[names.label]).join(" / ")
      }, path.map((option, index) => {
        const label = option[names.label];
        const matchedLabels = label.match(RegExp(inputValue, "i"));
        const splitLabelElements = label.split(RegExp(inputValue, "i"));
        const highLightLabelElements = [];
        splitLabelElements.forEach((item, i) => {
          highLightLabelElements.push(item);
          if (i !== splitLabelElements.length - 1 && matchedLabels?.[i]) {
            highLightLabelElements.push(/* @__PURE__ */ React.createElement("span", {
              style: {color: "red"}
            }, matchedLabels[i]));
          }
        });
        if (index !== path.length - 1) {
          highLightLabelElements.push(/* @__PURE__ */ React.createElement("span", null, " / "));
        }
        return highLightLabelElements;
      }));
    }
  };
  return /* @__PURE__ */ React.createElement(Cascader, {
    expandTrigger: "hover",
    fieldNames: {label: "name", value: "id"},
    onPopupVisibleChange: (popupVisible) => {
      if (popupVisible && categories?.length === 0) {
        run();
      }
    },
    showSearch,
    placeholder: formatMessage({id: "selectCategories"}),
    ...restProps,
    value,
    onChange,
    disabled: !channelId || !countryCode || disabled,
    options: categories
  });
}
